import { createFileRoute } from '@tanstack/react-router';

import { RadiologyReportDocumentPage } from '@/pages/blood-report/documents/radiology-report';

export const Route = createFileRoute(
  '/blood-report/_role-guard/$id/documents/radiology-report/$studyId',
)({
  component: RadiologyReportDocumentPage,
});
